import { createAction, props } from '@ngrx/store';

import { DeliveryAsset, OfflineDownloadStatus } from '../../models/delivery-asset.model';

const actionKey = '[Offline Event Statuses]';

export const sendOfflineDwnlStatus = createAction(
  `${actionKey} send offline dwnl status`,
  props<{ asset: DeliveryAsset; eventStatus: OfflineDownloadStatus }>(),
);
export const sendOfflineDwnlStatusSuccess = createAction(
  `${actionKey} send offline dwnl status success`,
  props<{ eventStatus: string; deliveryKeyCode: string }>(),
);
export const sendOfflineDwnlStatusFail = createAction(`${actionKey} send offline dwnl status fail`);

export const sendOfflineDeleteStatusSuccess = createAction(
  `${actionKey} send offline delete status success`,
);
export const sendOfflineDeleteStatusFail = createAction(
  `${actionKey} send offline delete status fail`,
);

export const sendOfflinePlayStatus = createAction(
  `${actionKey} send offline play status`,
  props<{ asset: DeliveryAsset; playCount }>(),
);
export const sendOfflinePlayStatusSuccess = createAction(
  `${actionKey} send offline play status success`,
);
export const sendOfflinePlayStatusFail = createAction(`${actionKey} send offline play status fail`);

export const sendOfflineStoredEvents = createAction(`${actionKey} send offline stored status`);
export const sendOfflineStoredEventsSuccess = createAction(
  `${actionKey} send offline stored status success`,
);
export const sendOfflineStoredEventsFail = createAction(
  `${actionKey} send offline stored status fail`,
);

export const downloadNext = createAction(
  `${actionKey} download next`,
  props<{ deliveryKeyCode: string; eventStatus: string }>(),
);
